/**
 * Redux Store Configuration
 *
 * Central store setup using Redux Toolkit's configureStore.
 * All feature reducers are combined in rootReducer.ts
 */
import { configureStore } from '@reduxjs/toolkit';
import { rootReducer, type RootState } from './rootReducer';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serializable check (SSE streaming, Date objects)
        ignoredActions: ['chat/streamMessage', 'chat/sendMessage/pending'],
        // Ignore these paths in the state
        ignoredPaths: ['chat.messages'],
      },
    }),
  devTools: import.meta.env.DEV,
});

// Re-export RootState from rootReducer (single source of truth)
export type { RootState };

// Infer the `AppDispatch` type from the store itself
export type AppDispatch = typeof store.dispatch;
